<template lang='pug'>
  router-link.logo(to='/')
    logo-icon.icon
    span.diginomix DigiNomix
</template>

<script>
  export default {
    name: 'logo'
  }
</script>

<style scoped lang='stylus'>
  .logo
    padding-right .24em
    letter-spacing 2px
    color rgba(30,55,70,.75)
    font-family "Expletus Sans"
    line-height 1.28
    text-shadow var(--text-shadow)
    .diginomix
      animation text-slider 2100ms
      position relative
      font-size .92em
    .icon
      position relative
      color rgba(125 75 55 1)
      filter drop-shadow( var(--text-shadow) )
      transform rotate(990deg)
      top .19em
      left -.08em
      animation logo-spinner 2100ms
      margin-right 4px
</style>
